import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CustomerTypeApi from '../api/customer_type/customer_type.ts';

export const fetchCustomerTypeAsync = createAsyncThunk(
    'customerType/fetchCustomerType',
    async () => {
        const response = await CustomerTypeApi();
        return response;
    }
);

const customerTypeSlice = createSlice({
    name: 'customerType',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCustomerTypeAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchCustomerTypeAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchCustomerTypeAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export default customerTypeSlice.reducer;